import React, { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { MainContent } from "../../layouts/MainContent";
import { Headers } from "../../layouts/headers/headers";
import { CategorieList } from "../../components/datatable/CategorieList";
import { FaFolderPlus } from "react-icons/fa"; // Ícono liviano

// ✅ Modales lazy
const UserModal = lazy(() => import("../../components/modals/profileUser"));
const PermissionDeniedModal = lazy(() => import("../../components/modals/denegPermisse"));
const SelectElement = lazy(() => import("../../components/modals/selectorElement"));
const CatReset = lazy(() => import("../../components/modals/ResetCat"));
const ListSkills = lazy(() => import("../../components/datatable/SkillsList"));

const Categorie = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectCategorie, setSelectCategorie] = useState(null);
  const [activeModal, setActiveModal] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const navigate = useNavigate();


  const handleRefresh = (updatedCategory = null) => {
    if (updatedCategory) {
      // Actualiza la categoría específica
      setCategories(prev =>
        prev.map(cat => cat.id === updatedCategory.id ? updatedCategory : cat)
      );
      setSelectCategorie(updatedCategory); // para pasar datos actualizados a ListSkills
    } else {
      setRefresh(prev => !prev); // fuerza el refresco completo
    }
  };

  const closePermissionModal = () => {
    setShowPermissionModal(false);
    navigate("/Control-Tecnico");
  };

  const openModal = (modalType, categorie) => {
    setSelectCategorie(categorie);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setSelectCategorie(null);
    setActiveModal(null);
  };

  return (
    <div className="flex h-screen">
      <Headers />

      <MainContent>
        <HeadersCentral
          showDropdown={showDropdown}
          setShowDropdown={setShowDropdown}
          openModal={() => openModal('user')}
        />

        <main className="p-6">
          <h1 className="text-2xl font-bold mb-7">Panel de Categorías de Servicios</h1>

          {/* Botón Nueva Categoría */}
          <div className="mb-4">
            <button
              className="bg-purple-700 hover:bg-purple-400 text-white font-semibold py-2 px-4 rounded-lg shadow-md flex items-center gap-2 w-auto"
              onClick={() => openModal('add')}
            >
              <FaFolderPlus size={16} /> Nueva
            </button>
          </div>

          {/* Tabla de categorías */}
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <CategorieList
              categories={categories}
              setCategories={setCategories}
              openModal={openModal}
              refresh={refresh}
            />
          </div>
        </main>
      </MainContent>
      {/* Modales */}
      <Suspense fallback={null}>
        {showPermissionModal && (
          <PermissionDeniedModal
            isOpen={showPermissionModal}
            onClose={closePermissionModal}
          />
        )}
        {activeModal === 'user' && <UserModal isOpen={true} onClose={closeModal} />}
        {activeModal === 'add' && (
          <SelectElement
            isOpen={true}
            onClose={closeModal}
            onSuccess={handleRefresh}
          />
        )}
        {activeModal === 'editCat' && (
          <CatReset
            isOpen={true}
            onClose={closeModal}
            categoryData={selectCategorie}
            onSuccess={handleRefresh}
          />
        )}
        {activeModal === 'editHab' && (
          <ListSkills
            isOpen={true}
            onClose={closeModal}
            skillList={selectCategorie?.subcategories || []}
            onSuccess={handleRefresh}
          />
        )}
      </Suspense>
    </div>
  );
};

export default Categorie;
